import React from 'react';
import { Router, Switch } from 'react-router-dom';
import { GuardedRoute } from '@4r/module-common-authorization';
import MainContainer, { IMainContainerProps } from './MainContainer';
import WebClockView from '../views/WebClockView/WebClockView';
import PermissionType from '../authorization/PermissionType';

const AppContainer: React.FC<React.PropsWithChildren<IMainContainerProps>> = ({
  settings,
  currentUser,
}) => (
  <MainContainer settings={settings} currentUser={currentUser}>
    <Router history={window.__mf.history}>
      <Switch>
        <GuardedRoute
          path="/time-attendance/web-clock"
          permissionType={PermissionType.ViewWebClock}
          exact
        >
          <WebClockView />
        </GuardedRoute>
      </Switch>
    </Router>
  </MainContainer>
);

export default AppContainer;
